import { NgModule, NgModuleFactoryLoader, SystemJsNgModuleLoader } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicContentOutletErrorComponent, DynamicContentOutletDirective, DynamicComponentOutletDirective } from './components';

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicContentOutletErrorComponent, DynamicContentOutletDirective, DynamicComponentOutletDirective],
  entryComponents: [DynamicContentOutletErrorComponent],
  exports: [DynamicContentOutletDirective, DynamicContentOutletErrorComponent, DynamicComponentOutletDirective],
  providers: [
    {
      provide: NgModuleFactoryLoader,
      useClass: SystemJsNgModuleLoader
    }
  ]
})
export class DynamicOutletModule {}
